import { getLocale } from "../runtime";

const da_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denne side tager lidt mig-tid. Det har vi alle brug for indimellem.`
};

const en_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `This page is taking some me-time. We all need that sometimes.`
};

const es_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Esta página está tomando un tiempo para sí misma. Todos necesitamos eso a veces.`
};

const fi_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tämä sivu pitää omaa aikaa. Sitä me kaikki tarvitsemme joskus.`
};

const nb_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denne siden tar litt meg-tid. Det trenger vi alle av og til.`
};

const sv_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denna sida tar lite egentid. Det behöver vi alla ibland.`
};

const easteregg4 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_easteregg4(inputs)
	if (locale === "en") return en_easteregg4(inputs)
	if (locale === "es") return es_easteregg4(inputs)
	if (locale === "fi") return fi_easteregg4(inputs)
	if (locale === "nb") return nb_easteregg4(inputs)
	if (locale === "sv") return sv_easteregg4(inputs)
	return "easterEgg4";
};

export { easteregg4 as "easterEgg4" };